"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecurityCode = void 0;
/**
 * 安全组件结果
 */
var SecurityCode;
(function (SecurityCode) {
    /**
     * 校验通过
     */
    SecurityCode[SecurityCode["success"] = 0] = "success";
    /**
     * 用户主动取消
     */
    SecurityCode[SecurityCode["cancel"] = 1] = "cancel";
    /**
     * 默认失败
     */
    SecurityCode[SecurityCode["fail"] = 2] = "fail";
    /**
     * 设备绑定校验失败
     */
    SecurityCode[SecurityCode["deviceRebind"] = 3] = "deviceRebind";
})(SecurityCode = exports.SecurityCode || (exports.SecurityCode = {}));
